module.exports = __webpack_public_path__ + "img/tuletorn_kaugelt.07ec9265.jpg";